"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.idxList = void 0;
function idxList(len, delta) {
    if (delta === void 0) { delta = 0; }
    return Array.from(Array(len), function (_v, k) { return k + delta; });
}
exports.idxList = idxList;
